module.exports = __webpack_public_path__ + "img/wa-icon.24b247ef.svg";